import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import { CashTenureApi, CashTenureApi_extrareducer } from './cash-tenure/index';

const initialState = {
  cashTenureApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const CashTenureSlice = createSlice({
  name: 'cashTenure',
  initialState,
  extraReducers: {
    ...CashTenureApi_extrareducer,
  },
});

export function useCashTenureStore() {
  const cashTenureApiState = useSelector(
    (state) => state.cashTenure.cashTenureApiState
  );

  const dispatch = useDispatch();

  return {
    cashTenureApiState,
    CashTenureApi: (payload) => dispatch(CashTenureApi(payload)),
  };
}

export default CashTenureSlice.reducer;
